// 订单/开门识别状态的统一格式化能力
// 抽取自 Order.vue，供交易复核等页面复用，避免重复建设。
// 所有函数接受 i18n 的 t 方法，返回多语言文本。

// 支付状态标签类型（element-ui tag type）
// payState: 1=成功, 0/2=处理中, 3=退款
export const payStateTagType = status => {
  if ([1].includes(status)) {
    return "success";
  }
  if ([0, 2].includes(status)) {
    return "warning";
  }
  return "info";
};

export const payStateTagIcon = status => {
  const tagType = payStateTagType(status);
  if (tagType === "success") {
    return "el-icon-success";
  }
  if (tagType === "warning") {
    return "el-icon-time";
  }
  return "el-icon-info";
};

// 开门识别结果
export const formatDoorVerifyStatus = (t, status) => {
  const statusMap = {
    1: t("order.doorVerifyStatus1"),
    2: t("order.doorVerifyStatus2"),
    3: t("order.doorVerifyStatus3"),
    4: t("order.doorVerifyStatus4"),
    6: t("order.doorVerifyStatus6"),
    7: t("order.doorVerifyStatus7"),
    8: t("order.doorVerifyStatus8"),
    9: t("order.doorVerifyStatus9"),
    10: t("order.doorVerifyStatus10")
  };
  return statusMap[status] || "-";
};

// 识别结果标签类型：2/3=成功, 1=待处理, 4/6-10=异常
export const doorVerifyStatusTagType = status => {
  if ([2, 3].includes(status)) {
    return "success";
  }
  if ([1].includes(status)) {
    return "warning";
  }
  if ([4, 6, 7, 8, 9, 10].includes(status)) {
    return "danger";
  }
  return "info";
};

export const doorVerifyStatusTagIcon = status => {
  const tagType = doorVerifyStatusTagType(status);
  if (tagType === "success") {
    return "el-icon-success";
  }
  if (tagType === "warning") {
    return "el-icon-time";
  }
  if (tagType === "danger") {
    return "el-icon-warning";
  }
  return "el-icon-info";
};

// 识别类型
export const formatDetectType = (t, type) => {
  const typeMap = {
    1: t("order.visualWeight"),
    2: t("order.visual"),
    3: t("order.weight")
  };
  return typeMap[type] || "-";
};

// 重量校验结果
export const formatSysVerifyWeight = (t, status) => {
  const statusMap = {
    0: t("order.sysVerifyWeight0"),
    1: t("order.sysVerifyWeight1"),
    2: t("order.sysVerifyWeight2")
  };
  return statusMap[status] || "-";
};

// 告警处理结果
export const formatUserVerifyStatus = (t, status) => {
  const statusMap = {
    1: t("order.userVerifyStatus1"),
    2: t("order.userVerifyStatus2")
  };
  return statusMap[status] || "-";
};

export const formatOpenDoorStatus = (t, status) => {
  const statusMap = {
    1: t("order.openDoorStatus1"),
    2: t("order.openDoorStatus2"),
    3: t("order.openDoorStatus3")
  };
  return statusMap[status] || "-";
};

// 是否为“识别未通过/异常”的订单（识别结果落在异常区间）
export const isRecognitionFailed = status => [4, 6, 7, 8, 9, 10].includes(status);

// 是否为需要人工复核处理的订单（告警待处理且未退款）
export const needsReview = order => {
  if (!order) {
    return false;
  }
  return Number(order.userVerifyStatus) === 2 && Number(order.payState) !== 3;
};

// 是否需要进入「对账/复核」流程：告警待处理（needsReview）或识别未通过
// （isRecognitionFailed）都应可对账，且订单尚未整单退款。修正了此前仅
// userVerifyStatus===2 才可操作、导致识别失败订单无对账入口的缺口。
export const needsReconcile = order => {
  if (!order) {
    return false;
  }
  if (Number(order.payState) === 3) {
    return false;
  }
  return needsReview(order) || isRecognitionFailed(order.doorVerifyStatus);
};

export default {
  payStateTagType,
  payStateTagIcon,
  formatDoorVerifyStatus,
  doorVerifyStatusTagType,
  doorVerifyStatusTagIcon,
  formatDetectType,
  formatSysVerifyWeight,
  formatUserVerifyStatus,
  formatOpenDoorStatus,
  isRecognitionFailed,
  needsReview,
  needsReconcile
};
